<template>
  <div class="work_code_type">
    <div
      style="display: flex; justify-content: space-between"
      class="search-bar-margin-bottom-cla"
    >
      <el-form :inline="true" :model="searchFrom">
        <el-form-item>
          <el-input
            @clear="getWorkCodeType"
            clearable
            v-model.trim="searchFrom.typeName"
            :placeholder="this.$t('common.search')"
            @keyup.enter.native="getWorkCodeType"
          >
            <el-button
              @click="getWorkCodeType"
              slot="append"
              icon="el-icon-search"
            ></el-button>
          </el-input>
        </el-form-item>
      </el-form>

      <el-button @click.stop="addcode" type="primary">{{
        $t('attendanceCode.newOrgCode')
      }}</el-button>
    </div>
    <el-table
      :highlight-current-row="true"
      @current-change="currentChange"
      :data="tableData"
      ref="workCodeTypeTable"
    >
      <el-table-column prop="type" :label="this.$t('common.type')">
        <template slot-scope="scope">
          <template v-if="scope.row.idEdit">
            <el-input
              v-model="scope.row.type"
              :placeholder="$t('common.enterValue')"
            ></el-input>
          </template>
          <template v-else>
            <span>{{ scope.row.type }}</span>
          </template>
        </template>
      </el-table-column>

      <el-table-column prop="typeName" :label="this.$t('common.Label')">
        <template slot-scope="scope">
          <template v-if="scope.row.idEdit">
            <el-input
              v-model="scope.row.typeName"
              :placeholder="$t('common.enterValue')"
            ></el-input>
          </template>
          <template v-else>
            <span>{{ scope.row.typeName }}</span>
          </template>
        </template>
      </el-table-column>

      <el-table-column prop="Enabled" :label="this.$t('common.Enabled')">
        <template slot-scope="scope">
          <template v-if="scope.row.idEdit">
            <el-switch
              v-model="scope.row.enable"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </template>
          <template v-else>
            <el-switch
              v-model="scope.row.enable"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              @change="changeEnable(scope.row)"
              inactive-value="0"
            ></el-switch>
          </template>
        </template>
      </el-table-column>

      <el-table-column :label="this.$t('common.action')">
        <template slot-scope="scope">
          <template v-if="scope.row.idEdit">
            <ZkButtonGroup
              :showTip="true"
              :params="scope.row"
              :showText="false"
              @editType="editRow(scope.row)"
              @saveType="saveItem(scope.row)"
              :event="['saveType', 'deleteType']"
              @deleteType="deleteFn(scope.$index, scope.row)"
              size="mini"
              groupName="enterprise_attendanceCode_left"
              :isGroup="true"
            ></ZkButtonGroup>
          </template>
          <template v-else>
            <ZkButtonGroup
              :showTip="true"
              :params="scope.row"
              :showText="false"
              @editType="editRow(scope.row)"
              @saveType="saveItem(scope.row)"
              @deleteType="deleteFn(scope.$index, scope.row)"
              :event="['editType', 'deleteType']"
              size="mini"
              groupName="enterprise_attendanceCode_left"
              :isGroup="true"
            ></ZkButtonGroup>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  getWorkCodeType,
  deleteWorkCodeType,
  saveOrUpdateWorkCodeType
} from '@/services/workcodeApi.js'
export default {
  data() {
    return {
      searchFrom: {
        typeName: ''
      },
      lastItem: null,
      tableData: []
    }
  },
  mounted() {
    this.getWorkCodeType()
  },
  methods: {
    changeEnable(row) {
      this.saveItem(row)
    },
    saveItem(row) {
      let params = {
        workCodeType: row
      }
      this.lastItem = row
      saveOrUpdateWorkCodeType(params)
        .then((data) => {
          if (data.code === '00000000') {
            this.getWorkCodeType()
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch((data) => {
          this.errorMessage()
        })
    },
    deleteFn(index, row) {
      if (!row.id) {
        this.tableData.splice(index, 1)
      } else {
        let params = {
          id: row.id
        }
        this.$confirm(
          this.$t('common.confirmDeleteRecordTip'),
          this.$t('common.warningNotice'),
          {
            confirmButtonText: this.$t('common.confirm'),
            cancelButtonText: this.$t('common.cancel'),
            type: 'warning'
          }
        )
          .then(() => {
            deleteWorkCodeType(params)
              .then((data) => {
                this.getWorkCodeType()
              })
              .catch((e) => {
                this.errorMessage()
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('common.cancelOperation')
            })
          })
      }
    },

    editRow(row) {
      this.tableData.forEach((item) => {
        item.idEdit = false
      })
      row.idEdit = true
    },

    currentChange(currentRow, oldCurrentRow) {
      try {
        if (!oldCurrentRow) {
          this.$emit('SelectType', currentRow)
        } else if (currentRow.id && currentRow.id !== oldCurrentRow.id) {
          this.$emit('SelectType', currentRow)
        }
      } catch (e) {
        console.log(e)
      }
    },

    addcode() {
      this.tableData.forEach((item) => {
        item.idEdit = false
      })
      this.tableData.push({
        idEdit: true,
        id: '',
        type: '',
        typeName: '',
        enable: '1'
      })
    },
    setCurrent(row) {
      this.$refs.workCodeTypeTable.setCurrentRow(row)
    },
    getWorkCodeType() {
      let params = {
        typeName: this.searchFrom.typeName
      }
      getWorkCodeType(params)
        .then((data) => {
          if (data.code === '00000000') {
            let result = data.payload.results.workCodeTypeList
            let len = result.length
            for (let i = 0; i < len; i++) {
              result[i].idEdit = false
              if (this.lastItem && this.lastItem.type === result[i].type) {
                this.setCurrent(result[i])
              }
              this.tableData.push(result[i])
            }
            this.tableData = data.payload.results.workCodeTypeList
          }
        })
        .catch((e) => {
          this.errorMessage()
        })
    }
  }
}
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/attendanceCode/workCodeType.vue